import { Tooltip } from '@nextui-org/react';
import React from 'react';

import { ThemeProp } from '../../theme/Themes';
import { BasicInfoBox } from './VehicleCard';
import {
  Chip,
  InfoBoxChipsContainer,
  InfoBoxImageAndValuesContainer,
  InfoBoxTitle,
  InfoBoxValue,
  InfoBoxValueContainer,
  InfoBoxValuesContainer,
  NotDisplayedChipsIcon,
  PeopleTooltipContainer,
  VehicleInfoBoxContainer,
} from './VehicleCard.styles';

const renderTooltipContent = (data: ChipData) => (
  <InfoBoxImageAndValuesContainer>
    <InfoBoxValuesContainer>
      <InfoBoxValueContainer>
        <InfoBoxValue>{data.label}</InfoBoxValue>
      </InfoBoxValueContainer>
      <InfoBoxValueContainer>
        <InfoBoxValue color={(props: ThemeProp) => props.theme.colors.greyscale.c600}>{data?.extra}</InfoBoxValue>
      </InfoBoxValueContainer>
    </InfoBoxValuesContainer>
  </InfoBoxImageAndValuesContainer>
);

interface ChipData {
  label: string;
  extra?: string;
}

export interface ChipBox extends BasicInfoBox {
  chips: Array<ChipData>;
}

const VehicleChipBox = ({ data }: { data: ChipBox }) => (
  <VehicleInfoBoxContainer>
    {data.title && <InfoBoxTitle>{data.title}</InfoBoxTitle>}
    <InfoBoxChipsContainer>
      {data.chips.length > 0 && (
        <Tooltip
          css={{
            padding: 0,
          }}
          content={
            <PeopleTooltipContainer>{data.chips.map((person) => renderTooltipContent(person))}</PeopleTooltipContainer>
          }
          hideArrow
          placement="bottom"
        >
          <InfoBoxChipsContainer>
            {data.chips.slice(0, 2).map((chip, index) => (
              <Chip key={`CardChip_${index}`}>{chip.label}</Chip>
            ))}
            {data.chips.length > 2 && <NotDisplayedChipsIcon>{`+${data.chips.length - 2}`}</NotDisplayedChipsIcon>}
          </InfoBoxChipsContainer>
        </Tooltip>
      )}
    </InfoBoxChipsContainer>
  </VehicleInfoBoxContainer>
);

export default VehicleChipBox;
